import { render, staticRenderFns } from "./SmallSpinner.vue?vue&type=template&id=e045718e&"
import script from "./SmallSpinner.vue?vue&type=script&lang=js&"
export * from "./SmallSpinner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports